import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import Debugger from './../debugger/Debugger';
import {
  changeImage,
  addDroppedImage,
} from '../../redux/actions/entities/pages';
import {
  changeTextureOrder,
  dpiResolution,
  addDroppedImageToTexture,
  toggleDpiOverlays,
} from '../../redux/actions/entities/placeholders';
import {
  getImageObjectById,
  convertObjectToArray,
  getBookSizes,
  getOriginalWidth,
  CM_TO_INCH,
  INCH_IN_PX,
  getFillSize,
  GetActivePage,
} from '../../redux/helpers/';
import { imageChange } from '../../redux/actions/ui/imageChange';
import './Texture.css';
import {
  fillImages,
  getEditorPlaceholderSizes,
  getImageOriginalSizes,
  getMoveXMoveY,
} from '../../redux/helpers/pages';
import { saveState } from '../../redux/actions/entities/io';
import { canDropImageToPlaceholder } from './../../helpers/dropHelper';
import { CALLIGRAFIA } from '../../helpers/coverHelper';

async function isSwapImage(props, sourceId) {
  const {
    pageId,
    texture,
    images,
    placeholders,
    pages,
    bookProperties
  } = props;

  const { id } = texture;
  const imageObject = getImageObjectById(images, sourceId);

  if (texture.isChanged || (texture.image === 0) || texture.image === undefined) {
    const imgs = props.images[sourceId];
    const droppedImageFillSize = fillImages(id, placeholders[id].order, imgs, props.placeholders, props.images, props.bookProperties.bookSizes, 0, false);

    const droppedFillSize = {
      width: droppedImageFillSize.fillsizes.width,
      height: droppedImageFillSize.fillsizes.height,
    };

    const activePage = GetActivePage(pages);
    if(!(bookProperties.cover.type === CALLIGRAFIA && activePage.isCover)){
      await props.dispatch(addDroppedImageToTexture(id, imageObject, sourceId, droppedFillSize));
      await props.dispatch(addDroppedImage(pageId, sourceId, true, id));
    }


    const { isCover } = props.pages[pageId];
    if (isCover) {
      const coverImages = Object.values((pages[pageId].droppedImages)).length;
      if (coverImages === 1 || coverImages === 2) {
        props.dispatch(imageChange(false));
      }
    } else {
      props.dispatch(imageChange(false));
    }
  }
}

const TextureTarget = {
  canDrop() {
    return true;
  },

  drop(props, monitor, component) {
    const {
      pageId, droppedImages, texture, backgroundType,
    } = props;
    const { type } = monitor.getItem();
    const sourceId = monitor.getItem().id;

    //  Enable texture image drop to editorScreen on consumer cover only
    if (!canDropImageToPlaceholder(backgroundType, type, props.pages[pageId])) {
      isSwapImage(props, sourceId);
      return { moved: true };
    }

    // Disable swap on fitted image
    if (texture.transformations.isFit) {
      return { moved: true };
    }

    const placeholderId = !type ? sourceId : props.placeholders[sourceId];

    if (!placeholderId) {
      return undefined;
    }

    const droppeId = convertObjectToArray(props.droppedImages).find(element => element.imageId === placeholderId.image);
    const targetId = convertObjectToArray(props.droppedImages).find(element => element.imageId === props.texture.image);

    if (!type && (!droppeId || !targetId)) {
      return undefined;
    }

    const droppedSwapplaceholderId = droppeId ? droppeId.id : placeholderId.image;
    const targetSwapplaceholderId = targetId ? targetId.id : props.texture.image;
    const droppedplaceholderId = !type ? droppeId.id : droppedSwapplaceholderId;
    const targetplaceholderId = !type ? targetId.id : targetSwapplaceholderId;


    const hasOrder = droppedImages[droppedplaceholderId] && droppedImages[targetplaceholderId];
    if (!hasOrder) {
      return undefined;
    }

    const dragOrder = droppedImages[droppedplaceholderId].order;
    const targetOrder = droppedImages[targetplaceholderId].order;

    const { id } = texture;

    const placeholdersSize = getEditorPlaceholderSizes(props.placeholders, id, props.bookProperties.bookSizes);
    const origImageSize = getImageOriginalSizes(props.placeholders, placeholderId.id, props.images, props.pages[pageId].droppedImages);
    const fromSizes = getFillSize(placeholdersSize, origImageSize, props.bookProperties.bookSizes, 0);

    const toPlaceholderSize = getEditorPlaceholderSizes(props.placeholders, placeholderId.id, props.bookProperties.bookSizes);
    const toOriginalImageSize = getImageOriginalSizes(props.placeholders, id, props.images, props.pages[pageId].droppedImages);
    const toSizes = getFillSize(toPlaceholderSize, toOriginalImageSize, props.bookProperties.bookSizes, 0);


    const { imageRatio } = props.placeholders[id];
    const { imageRatio: toRatio } = props.placeholders[placeholderId.id];
    const fromCenter = getMoveXMoveY(fromSizes, placeholdersSize, imageRatio);
    const toCenter = getMoveXMoveY(toSizes, toPlaceholderSize, toRatio);

    const toFillSizes = {
      width: toSizes.width,
      height: toSizes.height,
      originalWidth: toSizes.width,
      originalHeight: toSizes.width,
    };

    const fromFillSizes = {
      width: fromSizes.width,
      height: fromSizes.height,
      originalWidth: fromSizes.width,
      originalHeight: fromSizes.height,
    };

    const toImageRatio = toSizes.width / toOriginalImageSize.width;
    const fromImageRatio = fromSizes.width / origImageSize.width;

    props.dispatch(changeImage(props.pageId, droppedplaceholderId, dragOrder, targetplaceholderId, targetOrder));
    props.dispatch(changeTextureOrder(
      props.texture.id,
      props.texture.image,
      props.placeholders[sourceId].id,
      props.placeholders[sourceId].image,
      toFillSizes,
      fromFillSizes,
      toImageRatio,
      fromImageRatio,
      fromCenter,
      toCenter,
    ));

    component.startRendering();
    component.setDebounce();
    props.dispatch(saveState());

    return { moved: true };
  },
};

function collect(connected, monitor) {
  return {
    connectDropTarget: connected.dropTarget(),
    isOver: monitor.isOver(),
    isOverCurrent: monitor.isOver({ shallow: true }),
    canDrop: true,
    itemType: monitor.getItemType(),
  };
}

class Texture extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
    this.setTimeout = null;
  }

  componentWillUpdate(nextProps) {
    const {
      pageId, pages, texture,
    } = nextProps;
    const { isCover, isActive } = pages[pageId];

    if (isActive && isCover && Object.values(nextProps.droppedImages).length === 1) {
      const coverImages = Object.values((pages[pageId].droppedImages)).length;
      const placeholderSize = Object.values((pages[pageId].placeholders)).length;
      if (coverImages === placeholderSize && !texture.isChanged) {
        this.props.dispatch(imageChange(false));
      }
    }

    const bookSizes = {
      width: Math.round(((getBookSizes().pageWidth / 10) * CM_TO_INCH) * INCH_IN_PX),
    };

    if (this.props.texture.transformations.scaleX !== nextProps.texture.transformations.scaleX) {
      const {
        width, id, imageObject,
      } = nextProps.texture;
      let isReachMinimum = false;
      if (!imageObject) {
        return false;
      }
      const zoomLevel = this.props.texture.transformations.scaleX;
      const bookRatio = bookSizes.width / getOriginalWidth(this.props.bookProperties.bookSizes);
      if ((width * bookRatio) / 3 > imageObject.originalWidth / zoomLevel) {
        isReachMinimum = true;
      }

      if (isReachMinimum) {
        const { DPI } = nextProps.texture;
        if (!DPI.isSmall && !DPI.isClicked) {
          this.props.dispatch(dpiResolution(id, true));
        }
      }
    }
  }

  setDebounce = () => {
    this.setTimeout = clearTimeout(this.setTimeout);
    this.setTimeout = setTimeout(this.stopRendering, 5800);
  }

  startRendering = () => {

  }

  stopRendering = () => {

  }

  removeOverlay = () => {
    this.props.dispatch(toggleDpiOverlays(true));
  }

  renderButton() {
    const {
      DPI, imageRatio,
    } = this.props.texture;

    const { imageObject } = this.props.texture;

    if (!imageObject) {
      return;
    }
    let isReachMinimum = false;

    if (imageRatio > 3) {
      isReachMinimum = true;
    }

    if (isReachMinimum && !DPI.isClicked) {
      return <button className="dpi-button" onClick={this.removeOverlay}>Ok</button>;
    }
  }

  renderCanvas = () => {
    const {
      width,
      height,
      imageObject: { mediumThumbnail } = { mediumThumbnail: '' },
      imageObject: { originalWidth } = { originalWidth: '' },
      imageObject: { originalHeight } = { originalHeight: '' },
      imageObject: { mediumThumbnailPath } = { mediumThumbnailPath: '' },
      imageObject: { fileName } = { fileName: '' },
      id,
      isChanged,
      transformations,
      DPI,
      imageRatio,
    } = this.props.texture;

    const {
      index,
      ratio,
      onMouseDown,
      onMouseMove,
      onMouseUp,
      onClick,
      DPIResolution,
      isPreview,
      bookProperties,
    } = this.props;

    return (
      <div className="canvas-wrapper">
        <Debugger
          placeholderId={id}
          image={`${mediumThumbnailPath || ''}${fileName || ''}`}
          zoom={transformations.scaleX}
          rotate={transformations.rotate}
          placeholderWidth={width}
          placeholderHeight={height}
          fillWidth={transformations.fillSizes.width}
          fillHeight={transformations.fillSizes.height}
          autofill={bookProperties.autofill}
          originalImageWidth={originalWidth}
          originalImageHeight={originalHeight}
          X={transformations.moveX}
          Y={transformations.moveY}
        />
        <canvas
          ref={`canvas-${index}`}
          data-image-url={mediumThumbnail || ''}
          data-imageWidth={originalWidth || ''}
          data-DPI={isPreview ? '' : DPIResolution}
          data-isClicked={isPreview ? '' : DPI.isClicked}
          data-imageRatio={imageRatio}
          data-placeholderId={id}
          key={index}
          data-index={index}
          data-scale={transformations.scaleX}
          width={Math.round(width * ratio)}
          data-isChanged={isChanged}
          height={Math.round(height * ratio)}
          className={`canvas-${index}`}
          onMouseDown={onMouseDown}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUp}
          onClick={onClick}
        />

        {isPreview ? '' : this.renderButton()}
      </div>
    );
  }

  render() {
    const {
      connectDropTarget,
    } = this.props;

    return connectDropTarget(this.renderCanvas());
  }
}

Texture.defaultProps = {
  index: 0,
  texture: {},
  ratio: 0,
  onMouseDown: () => {},
  onMouseMove: () => {},
  onMouseUp: () => {},
  onClick: () => {},
  DPIResolution: false,
  bookProperties: {},
};

Texture.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  index: PropTypes.number,
  texture: PropTypes.object,
  ratio: PropTypes.number,
  onMouseDown: PropTypes.func,
  onMouseMove: PropTypes.func,
  onMouseUp: PropTypes.func,
  onClick: PropTypes.func,
  DPIResolution: PropTypes.bool,
  bookProperties: PropTypes.object,
};

Texture = DropTarget(['Image', 'SwapImageIcon'], TextureTarget, collect)(Texture);
export default connect(state => ({
  bookProperties: state.bookProperties,
  pages: state.entities.pages.byId,
  backgroundType: state.editorUI.bookProperties.backgroundType,
}))(Texture);



// WEBPACK FOOTER //
// ./src/components/texture/Texture.jsx